let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jGMLP")).then(() => parcelRequire('5TZJO'));